import { Badge } from "@/components/ui/badge";
import { isHmsCommodity } from "@/lib/hms";

// Navy/gold suite badge: "HMS" when the project runs the Heavy-Mineral-Sands suite, otherwise a
// muted "Standard" badge. Prefers the backend `hms` flag (commodity OR any HMS area/mineral) and
// falls back to the primary commodity. Mirrors backend HMS gating.
export const SuiteBadge = ({ commodity, id, hms }) => {
  const isHms = hms === undefined ? isHmsCommodity(commodity) : !!hms;
  return isHms ? (
    <Badge className="text-[10px] font-bold border-transparent" style={{ background: "#0B1420", color: "#FFFFFF" }}
      data-testid={id ? `project-suite-${id}` : "project-suite"}>HMS</Badge>
  ) : (
    <Badge variant="outline" className="text-[10px] font-semibold text-slate-500"
      data-testid={id ? `project-suite-${id}` : "project-suite"}>Standard</Badge>
  );
};
